export default () => process.env.APP_VERSION
